export const invitationsEndpoints = {
    accept: (token: string): string => `/api/invitations/accept/${token}`,
    validate: (token: string): string => `/api/invitations/validate/${token}`,
} as const;
